import React from "react";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { imageServerUrl } from "../../utils";
import ChangeZip from "./ChangeZip";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    overflow: "auto",
    width: theme.spacing(60),
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(45),
      padding: theme.spacing(2),
      maxHeight: "100%",
      // height: theme.spacing.unit * 75,
      overflow: "scroll",
    },
    [theme.breakpoints.up("md")]: {
      width: theme.spacing(50),
      padding: theme.spacing(4),
      // maxHeight: theme.spacing.unit * 80,
      // height: "100%"
    },
    [theme.breakpoints.up("lg")]: {
      width: theme.spacing(69),
      padding: theme.spacing(5),
      // height: "100%",
      // maxHeight: theme.spacing.unit * 82
    },
  },
}));

export default React.forwardRef(function ChangeZipModal(props, ref) {
  const { onClose } = props;
  const classes = useStyles();
  return (
    <>
      <Paper
        style={{
          top: "50%",
          left: "50%",
          transform: `translate(-50%, -50%)`,
        }}
        className={classes.paper}
      >
        <button
          type="button"
          className="tw-float-right close-button-modal"
          onClick={onClose}
        >
          <i className="fas fa-times" />
        </button>
        <div>
          <div className="tw-text-center tw-flex tw-justify-center">
            <img
              src={`${imageServerUrl}/logo-skipti-vertical.jpg`}
              alt="skipti logo"
              className="m_6073652373047506906fr-fic m_6073652373047506906fr-dib CToWUd"
            />
          </div>
          {/* <p className="small" style={{ textAlign: "center" }}>
            <em>
              Send a friend $20 to rent. Your account will be credited after
              they complete their first rental with Skipti.
            </em>
          </p> */}
          <p className="tw-text-center">
            Please add your zip code to be able to see items that are available
            for delivery in your region:
          </p>{" "}
          <ChangeZip withSubmitButton />
        </div>
      </Paper>
    </>
  );
});
